import React from "react";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0d3b34] text-white relative overflow-hidden">
      {/* Wave Background */}
      <div className="absolute top-0 left-0 w-full h-11 bg-white rounded-b-[100%_100%]"></div>

      {/* Main Content */}
      <div className="relative z-10 px-6 py-12 md:px-20 md:py-10 md:pt-25 flex flex-col md:flex-row justify-center gap-8">
        {/* Emergency Contact */}
        <div>
          <h2 className="text-lg font-semibold mb-4">Emergency Contact</h2>
          <div className="flex items-center gap-2 mb-2">
            <i className="fas fa-phone text-yellow-400"></i>
            <p className="text-gray-200">+91 9975922007</p>
          </div>
          <div className="flex items-center gap-2">
            <i className="fas fa-envelope text-yellow-400"></i>
            <p className="text-gray-200">doshi.santosh@rediffmail.com</p>
          </div>
        </div>

        {/* Location */}
        <div>
          <h2 className="text-lg font-semibold mb-4">Location</h2>
          <div className="flex items-start gap-2 mb-2">
            <i className="fas fa-map-marker-alt text-yellow-400 mt-1 flex-shrink-0"></i>
            <div>
              <p className="text-gray-200">RATANLAL TRADERS</p>
              <p className="text-gray-200">POST–WALCHANDNAGAR</p>
              <p className="text-gray-200">NEW BAZAR PETH</p>
              <p className="text-gray-200">PIN–413114</p>
            </div>
          </div>
        </div>

        {/* About */}
        <div>
          <h2 className="text-lg font-semibold mb-4">Siddhant Exim Academy</h2>
          <p className="text-gray-200 text-sm leading-relaxed">
            Siddhant Exim Academy: Expert Import/Export services, global trade <br />
            solutions, compliance, logistics, TPI, BPO, and UAE consulting.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h2 className="text-lg font-semibold mb-4">Quick Links</h2>
          <ul className="space-y-2 text-gray-200">
            <li><Link to="/" className="hover:text-yellow-400 transition">Home</Link></li>
            <li><Link to="/about" className="hover:text-yellow-400 transition">About Us</Link></li>
            <li><Link to="/reels" className="hover:text-yellow-400 transition">Reels</Link></li>
            <li><Link to="/privacypolicy" className="hover:text-yellow-400 transition">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>

      {/* Divider */}
      <div className="relative z-10 border-t border-gray-600 mt-6"></div>

      {/* Bottom Section */}
      <div className="relative z-10 flex flex-col md:flex-row justify-between items-center px-6 md:px-20 py-4 text-gray-300">
        <p className="text-sm">© 2025 Siddhant Exim Academy. All Rights Reserved.</p>
          <div className="flex space-x-5 mt-3 md:mt-0">
            <a
              href="https://www.instagram.com/sanntoshdoshi/?igshid=https%3A%2F%2Finstagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-yellow-400"
              aria-label="Instagram"
              title="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>

            <a
              href="https://www.facebook.com/sanntosh.doshi?mibextid=ZbWKwL"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-yellow-400"
              aria-label="Facebook"
              title="Facebook"
            >
              <i className="fab fa-facebook-f"></i>
            </a>

            <a
              href="https://api.whatsapp.com/send/?phone=919975922007&text&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-yellow-400"
              aria-label="WhatsApp"
              title="WhatsApp"
            >
              <i className="fab fa-whatsapp"></i>
            </a>

            <a
              href="https://www.linkedin.com/in/santosh-doshi-jain-2a13b3246"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-yellow-400"
              aria-label="LinkedIn"
              title="LinkedIn"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
      </div>
    </footer>
  );
};

export default Footer;